import { Component } from '@angular/core';
import { AFFILIATE_ENABLED } from '../../../shared/constants';
import { SidenavService } from '../services/sidenav.service';

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.scss'],
    standalone: true
})
export class AboutComponent {
  affiliateEnabled = AFFILIATE_ENABLED;
  constructor(private sidenavService: SidenavService) {
    this.sidenavService.close();
  }
}
